module.exports = __webpack_public_path__ + "img/tsi-logo.b7e86b4d.jpg";